export const gateABI = [
  {
    inputs: [
      {
        internalType: 'address',
        name: '_weth',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_config',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_handler',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'expected',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'actual',
        type: 'address',
      },
    ],
    name: 'BadInstrumentAddress',
    type: 'error',
  },
  {
    inputs: [],
    name: 'BlacklistedTrader',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InstrumentExists',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'requested',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'reserve',
        type: 'uint256',
      },
    ],
    name: 'InsufficientReserve',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidMsgValue',
    type: 'error',
  },
  {
    inputs: [],
    name: 'MarketTypeNotSupported',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'bytes',
        name: 'lowLevelData',
        type: 'bytes',
      },
    ],
    name: 'NewInstrumentFailed',
    type: 'error',
  },
  {
    inputs: [],
    name: 'NoDirectDeposit',
    type: 'error',
  },
  {
    inputs: [],
    name: 'NotHandler',
    type: 'error',
  },
  {
    inputs: [],
    name: 'NotInstrument',
    type: 'error',
  },
  {
    inputs: [],
    name: 'NotSynFuturesV3Admin',
    type: 'error',
  },
  {
    inputs: [],
    name: 'PendingDurationTooLong',
    type: 'error',
  },
  {
    inputs: [],
    name: 'PendingWithdrawNotMature',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token',
        type: 'address',
      },
    ],
    name: 'UnsafeToken',
    type: 'error',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'trader',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'banned',
        type: 'bool',
      },
    ],
    name: 'Blacklist',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'quote',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'trader',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'quantity',
        type: 'uint256',
      },
    ],
    name: 'Deposit',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'quote',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'trader',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'instrument',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint32',
        name: 'expiry',
        type: 'uint32',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'quantity',
        type: 'uint256',
      },
    ],
    name: 'Gather',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint8',
        name: 'version',
        type: 'uint8',
      },
    ],
    name: 'Initialized',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'bytes32',
        name: 'index',
        type: 'bytes32',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'instrument',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'base',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'quote',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'string',
        name: 'symbol',
        type: 'string',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'total',
        type: 'uint256',
      },
    ],
    name: 'NewInstrument',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'quote',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'trader',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'instrument',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint32',
        name: 'expiry',
        type: 'uint32',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'quantity',
        type: 'uint256',
      },
    ],
    name: 'Scatter',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'duration',
        type: 'uint256',
      },
    ],
    name: 'SetPendingDuration',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'quote',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'threshold',
        type: 'uint256',
      },
    ],
    name: 'SetThreshold',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'quote',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'trader',
        type: 'address',
      },
      {
        components: [
          {
            internalType: 'uint32',
            name: 'timestamp',
            type: 'uint32',
          },
          {
            internalType: 'bool',
            name: 'native',
            type: 'bool',
          },
          {
            internalType: 'uint96',
            name: 'amount',
            type: 'uint96',
          },
          {
            internalType: 'uint120',
            name: 'exemption',
            type: 'uint120',
          },
        ],
        indexed: false,
        internalType: 'struct Pending',
        name: 'pending',
        type: 'tuple',
      },
    ],
    name: 'UpdatePending',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'quote',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'trader',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'quantity',
        type: 'uint256',
      },
    ],
    name: 'Withdraw',
    type: 'event',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'allInstruments',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'allInstrumentsLength',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'config',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'arg',
        type: 'bytes32',
      },
    ],
    name: 'deposit',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'arg',
        type: 'bytes32',
      },
      {
        internalType: 'address',
        name: 'trader',
        type: 'address',
      },
    ],
    name: 'depositFor',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'quote',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'trader',
        type: 'address',
      },
    ],
    name: 'fundFlowOf',
    outputs: [
      {
        components: [
          {
            internalType: 'uint128',
            name: 'totalIn',
            type: 'uint128',
          },
          {
            internalType: 'uint128',
            name: 'totalOut',
            type: 'uint128',
          },
        ],
        internalType: 'struct FundFlow',
        name: 'fundFlow',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'quote',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'trader',
        type: 'address',
      },
      {
        internalType: 'uint32',
        name: 'expiry',
        type: 'uint32',
      },
      {
        internalType: 'uint256',
        name: 'quantity',
        type: 'uint256',
      },
    ],
    name: 'gather',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getAllInstruments',
    outputs: [
      {
        internalType: 'address[]',
        name: '',
        type: 'address[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'handler',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'instrument',
        type: 'address',
      },
    ],
    name: 'indexOf',
    outputs: [
      {
        internalType: 'bytes32',
        name: 'index',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'instrumentInitData',
    outputs: [
      {
        internalType: 'bytes',
        name: '',
        type: 'bytes',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
    ],
    name: 'isBlacklisted',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: 'mtype',
        type: 'string',
      },
      {
        internalType: 'address',
        name: 'instrument',
        type: 'address',
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes',
      },
      {
        internalType: 'bytes32[2]',
        name: 'addArgs',
        type: 'bytes32[2]',
      },
    ],
    name: 'launch',
    outputs: [
      {
        internalType: 'int24',
        name: 'tickLower',
        type: 'int24',
      },
      {
        internalType: 'int24',
        name: 'tickUpper',
        type: 'int24',
      },
      {
        components: [
          {
            internalType: 'uint128',
            name: 'liquidity',
            type: 'uint128',
          },
          {
            internalType: 'uint128',
            name: 'entryFeeIndex',
            type: 'uint128',
          },
          {
            internalType: 'uint96',
            name: 'balance',
            type: 'uint96',
          },
          {
            internalType: 'uint160',
            name: 'sqrtEntryPX96',
            type: 'uint160',
          },
        ],
        internalType: 'struct Range',
        name: 'range',
        type: 'tuple',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'pendingDuration',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'quote',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'trader',
        type: 'address',
      },
    ],
    name: 'pendingOf',
    outputs: [
      {
        components: [
          {
            internalType: 'uint32',
            name: 'timestamp',
            type: 'uint32',
          },
          {
            internalType: 'bool',
            name: 'native',
            type: 'bool',
          },
          {
            internalType: 'uint96',
            name: 'amount',
            type: 'uint96',
          },
          {
            internalType: 'uint120',
            name: 'exemption',
            type: 'uint120',
          },
        ],
        internalType: 'struct Pending',
        name: 'pending',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'quote',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'trader',
        type: 'address',
      },
    ],
    name: 'release',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'quote',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
    ],
    name: 'reserveOf',
    outputs: [
      {
        internalType: 'uint256',
        name: 'balance',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'quote',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'trader',
        type: 'address',
      },
      {
        internalType: 'uint32',
        name: 'expiry',
        type: 'uint32',
      },
      {
        internalType: 'uint256',
        name: 'quantity',
        type: 'uint256',
      },
    ],
    name: 'scatter',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'trader',
        type: 'address',
      },
      {
        internalType: 'bool',
        name: 'banned',
        type: 'bool',
      },
    ],
    name: 'setBlacklist',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'duration',
        type: 'uint256',
      },
    ],
    name: 'setPendingDuration',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'quote',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'threshold',
        type: 'uint256',
      },
    ],
    name: 'setThreshold',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'quote',
        type: 'address',
      },
    ],
    name: 'thresholdOf',
    outputs: [
      {
        internalType: 'uint256',
        name: 'threshold',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'weth',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'arg',
        type: 'bytes32',
      },
    ],
    name: 'withdraw',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'arg',
        type: 'bytes32',
      },
      {
        internalType: 'address',
        name: 'trader',
        type: 'address',
      },
    ],
    name: 'withdrawFor',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    stateMutability: 'payable',
    type: 'receive',
  },
];
